// Testing data until we start to load it from client.
export { ChatAgent, CommsCrafterAgent, JobWriterAgent, A11yMateAgent } from './mock-agents';
/**
 * Pulls out the necessary fields from the raw agent data received to create an EditorAgent.
 *
 * @param rawAgentData
 */
export const getEditorAgent = rawAgentData => {
  const {
    id,
    name,
    description,
    named_id,
    creator_type,
    system_prompt_template,
    creator,
    visibility,
    is_default,
    conversation_starters
  } = rawAgentData;

  // TODO: we can use this place to populate additional fields like color, iconInitials etc.

  return {
    id,
    name,
    description,
    namedId: named_id,
    creatorType: creator_type,
    systemPromptTemplate: system_prompt_template,
    creator: creator !== null && creator !== void 0 ? creator : undefined,
    visibility,
    isDefault: is_default,
    conversationStarters: conversation_starters !== null && conversation_starters !== void 0 ? conversation_starters : []
  };
};